import { computed, Injectable, signal } from '@angular/core';
import { StoryDialogConfig } from '../interfaces/story.interface';

@Injectable({
  providedIn: 'root',
})
export class ViewStoryService {
  config: StoryDialogConfig = {
    story: null,
    item: null,
    allowEdit: true,
    allowShare: true,
    fromModal: true,
    accessDraft: true,
    isPageClicked: false,
    pageIndex: 0,
    selectedTab: 'story',
    viewType: 'community',
    campaignId: null,
    enableMeta: false,
    userAccessLevel:true,
    isPrivateLink:false
  };

  private _toggle = signal<StoryDialogConfig | null>(null);

  toggle = computed(() => this._toggle());

  show(config: Partial<StoryDialogConfig>){
    this._toggle.set({
      ...this.config,
      ...config
    });
  }

  hide(){
    this._toggle.set(null);
  }

}
